import { CustomAxiosRequestConfig, http } from '@/core/helpers/axiosHelper';
import { LocationQuery } from 'vue-router';
import {
   CustomerPerformancesOverview,
   PaginatedPerformancesOverviewResponse,
   PerformanceOverview,
} from '../../performances-overview/performance-overview.interface';
import { isOverviewPaginationMeta } from '@/core/models/overview-pagination.interface';

export class PerformanceOverviewService {
   async getPerformanceOverview(customerId: number, employeeId: number, query?: LocationQuery): Promise<PerformanceOverview | null> {
      const response = await http.get<CustomerPerformancesOverview | PaginatedPerformancesOverviewResponse>(`/performances-overview`, {
         cancelable: false,
         params: { ...query, customer_id: customerId, employee_id: employeeId },
      } as CustomAxiosRequestConfig);
      const data = response.data;

      if (data?.customers && isOverviewPaginationMeta(data.meta)) {
         const customer = data.customers.find((item) => item.id === customerId) ?? data.customers[0];
         return customer?.performances_overview?.find((overview) => overview.id === employeeId) ?? null;
      }

      return data.performances_overview?.[0] ?? null;
   }
}
